import _defineProperty from "@babel/runtime/helpers/defineProperty";
var $ = jQuery;

// Modules
import StarsBackground from "./modules/stars-background";
'./modules/stars-background';
import hide_on_scroll from './modules/hide-on-scroll';

// Features
import '../../features/videos/videos';
import '../../features/testimonials/testimonials';
$(function () {
  /*
   * Fix mobile menu modal for anchor links
   */
  $('nav.is-responsive a').on('click', function (e) {
    var $container = $(e.currentTarget).closest('.wp-block-navigation__responsive-container');
    $container.removeClass('is-menu-open has-modal-open');
    $('html').removeClass('has-modal-open');
  });

  /*
   * Apply has-value attributes on form fields
   */

  var $forms = $('.wpcf7-form, .AlistSubscribeForm');
  var $inputs = $('.wpcf7-form-control, .AlistSubscribeForm-input');
  var fieldWrapper = '.field-wrapper';

  // set data-focussed based on focus/blur state
  $inputs.on('focus blur', function (e) {
    $(this).closest(fieldWrapper).attr('data-focused', e.type == 'focus');
  });
  $inputs.on('blur', function (e) {
    var $input = $(this);
    var hasValue = $input.val() != undefined && $input.val() != '';
    $input.closest(fieldWrapper).attr('data-has-value', hasValue);
  });
  $forms.on('reset', function (e) {
    var $form = $(e.currentTarget);
    $form.find(':focus').trigger('blur');
    $form.find('[data-has-value="true"]').attr('data-has-value', false);
  });

  /*
   * Init stars background
   */

  new StarsBackground('canvas#hero-background', _defineProperty(_defineProperty({
    star_color: ["#205375"],
    star_density: 0.01,
    star_size: 4,
    star_min_scale: 0.4
  }, "star_density", 0.005), "speed", 0.05));
  new StarsBackground('canvas#watch-online-background', _defineProperty(_defineProperty({
    star_color: ['#EFEFEF'],
    star_density: 0.01,
    star_size: 4,
    star_min_scale: 0.4
  }, "star_density", 0.005), "speed", 0.05));

  /*
   * Temporary alist show more
   */

  var $gigsTable = $('#alist-shows');
  var $shows = $gigsTable.find('.show:not(.header)');
  var increment = 10;
  var count = increment;
  var remaining = Math.max(0, $shows.length - count);
  $gigsTable.attr('data-remaining', remaining);
  if (remaining) {
    $shows.each(function (idx, el) {
      if (idx >= count) {
        $(el).attr('data-display', 'none');
      }
    });
    var $button = $("<button class=\"alist-shows-showmore\"></button>").text('Show all');
    $button.insertAfter($gigsTable);
    $button.on('click', function () {
      $shows.attr('data-display', 'initial');
      $button.remove();
    });
  }

  /*
   * Hide Nav Toggle on scroll
   */
  var $toggle = $('.wp-block-navigation__responsive-container-open');
  hide_on_scroll($toggle);
});